interface ModeBadgeProps {
  dryRun: boolean;
}
export default function ModeBadge({ dryRun }: ModeBadgeProps) {
  if (dryRun) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-paper/40 bg-paper/10 px-3 py-1 font-mono text-xs font-semibold uppercase tracking-wider text-paper">
        <span className="h-1.5 w-1.5 rounded-full bg-paper" />
        Paper
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-live/50 bg-live/10 px-3 py-1 font-mono text-xs font-semibold uppercase tracking-wider text-live">
      <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-live" />
      Live
    </span>
  );
}
